import {useAsync} from 'react-async-hook';
import {ClientTypes} from '..';
import {CognitoConfig, EvidentlyConfig} from '../types/config';
import {getFeatureToggleClient} from '../../soluto-private-mx-featuretoggle';

export function getClientHook(type: ClientTypes, evidentlyConfig?: EvidentlyConfig, cognitoConfig?: CognitoConfig) {
    return useAsync(async () => {
        const client = await getFeatureToggleClient(type);
        return client;
    }, [type, evidentlyConfig, cognitoConfig]);
}
